<template>
   <AboutUs/>
</template>

<script>
// import HeaderComponentVue from '../HeaderComponent.vue';
import AboutUs from './AboutUs.vue'

export default {
    name: 'AboutUsComponent',
    components: {
        // HeaderComponentVue,
        AboutUs,
    }
}
</script>